import CHIPS_RangeSlider from "./chips-rangeslider.js";

export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		this.filterParams = {
			filtersOpen: false,
		};
		this.activeFilterType = null;
		this.activeFilterValue = null;
		this.activeFilterValueMax = null;
		this.activeFilterValueDisplay = null;
		this.doURLChange = false;
		this.viewingSort = null;
		this.allowURLChange = true;
		this.safetyNet = null;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_GluckWorkFilters";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			const scopeThis = this;
			this.getInitialValues();

			this.$el
				.querySelector(".button__reset")
				.addEventListener("click", this.closeFilters.bind(this));

			this.$el.querySelectorAll('input[name="filter"]').forEach((el) => {
				// el.addEventListener("change", this.filtersChanged.bind(this));
				el.addEventListener("change", this.filtersPreviewed.bind(this));
			});
			this.$el.querySelectorAll(".typevalue").forEach((el) => {
				el.addEventListener("change", this.filtersChanged.bind(this));
			});
			this.$el.querySelectorAll(".scopevalue").forEach((el) => {
				el.addEventListener("change", this.filtersChanged.bind(this));
			});
			this.$el.querySelectorAll(".rolevalue").forEach((el) => {
				el.addEventListener("change", this.filtersChanged.bind(this));
			});
			if (this.$el.querySelector("#in-progress")) {
				this.$el
					.querySelector("#in-progress")
					.addEventListener("change", this.filtersChanged.bind(this));
			}
			// this.$el.querySelectorAll(".locationvalue").forEach((el) => {
			// 	el.addEventListener("change", this.filtersChanged.bind(this));
			// });

			let rangeSliderEls = this.$el.querySelectorAll(".filter__sliders");
			if (rangeSliderEls.length > 0) {
				rangeSliderEls.forEach((el) => {
					const rangeSlider = new CHIPS_RangeSlider({
						$el: el,
					});

					// listen for rangeChanged event
					rangeSlider.$el.addEventListener("rangeChanged", (e) => {
						clearTimeout(scopeThis.rangeChangedTimeout);
						scopeThis.rangeChangedTimeout = setTimeout(function () {
							scopeThis.doURLChange = "force";
							scopeThis.filtersChanged();
						}, 500);
					});
				});
			}

			let rangeSliderInputs = this.$el.querySelectorAll(
				".filter__inputs-wrap input"
			);
			if (rangeSliderInputs.length > 0) {
				rangeSliderInputs.forEach((inputEl) => {
					// listen for changes to the input fields
					inputEl.addEventListener("change", (e) => {
						// console.log(e.target.classList);
						// if e.target has class filter__sliders--size, set activeFilterType to size
						if (
							e.target.classList.contains("filter__sliders--size")
						) {
							this.activeFilterType = "size";
							this.activeFilterValue = this.$el.querySelector(
								'input[name="size_min"]'
							).value;
							this.activeFilterValueMax = this.$el.querySelector(
								'input[name="size_max"]'
							).value;
							this.doURLChange = "force";
							// trigger filtersChanged
							this.filtersChanged();
						} else if (
							e.target.classList.contains("filter__sliders--year")
						) {
							this.activeFilterType = "year";
							this.activeFilterValue = this.$el.querySelector(
								'input[name="filter__year--min"]'
							).value;
							this.activeFilterValueMax = this.$el.querySelector(
								'input[name="filter__year--max"]'
							).value;
							this.doURLChange = "force";
							// trigger filtersChanged
							this.filtersChanged();
						} else if (
							e.target.classList.contains(
								"filter__sliders--location"
							)
						) {
							this.activeFilterType = "location";
							this.activeFilterValue = this.$el.querySelector(
								'input[name="filter__location--min"]'
							).value;
							this.activeFilterValueMax = this.$el.querySelector(
								'input[name="filter__location--max"]'
							).value;
							this.doURLChange = "force";
							// trigger filtersChanged
							this.filtersChanged();
						}
					});
				});
			}

			this.postReturnCB();
		}
	}

	postReturnCB() {
		this.$el
			.querySelector(".button__showfilters")
			.addEventListener("click", this.showFilters.bind(this));

		if (this.$el.querySelector(".button__clearfilters")) {
			this.$el
				.querySelector(".button__clearfilters")
				.addEventListener("click", () => {
					this.$el
						.querySelectorAll('input[type="radio"]')
						.forEach((el) => {
							// if (el.name !== "filter") {
							el.checked = false;
							// }
						});
					this.$el.querySelector("#filter-type").checked = true;
					this.activeFilterType = null;
					this.activeFilterValue = null;
					this.activeFilterValueMax = null;
					this.activeFilterValueDisplay = null;
					this.previewFilterType = null;

					this.$el
						.querySelectorAll("input[data-reset]")
						.forEach((el) => {
							el.value = el.getAttribute("data-reset");
						});

					// .filter__block input[type="radio"] uncheck

					this.doURLChange = "force";
					this.filtersChanged();
					// this.setFilterURL();
				});
		}
	}

	getInitialValues() {
		let filter = this.$el.querySelector(
			'input[name="filter"]:checked'
		).value;
		if (filter) {
			if (filter === "type") {
				this.activeFilterType = "type";
				if (this.$el.querySelector('input[name="typevalue"]:checked')) {
					this.activeFilterType = "type";
					this.activeFilterValue = this.$el.querySelector(
						'input[name="typevalue"]:checked'
					).value;
					this.activeFilterValueDisplay = this.$el.querySelector(
						'input[name="typevalue"]:checked'
					).nextElementSibling.textContent;
				}
			} else if (filter === "size") {
				this.activeFilterType = "size";
				if (this.$el.querySelector('input[name="size__start"]')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="size__start"]'
					).value;
					this.activeFilterValueMax = this.$el.querySelector(
						'input[name="size__end"]'
					).value;
				}
			} else if (filter === "year") {
				this.activeFilterType = "year";
				if (this.$el.querySelector('input[name="year__start"]')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="year__start"]'
					).value;
					this.activeFilterValueMax = this.$el.querySelector(
						'input[name="year__end"]'
					).value;
				}
			} else if (filter === "scope") {
				this.activeFilterType = "scope";

				if (
					this.$el.querySelector('input[name="scopevalue"]:checked')
				) {
					this.activeFilterType = "scope";
					this.activeFilterValue = this.$el.querySelector(
						'input[name="scopevalue"]:checked'
					).value;
					this.activeFilterValueDisplay = this.$el.querySelector(
						'input[name="scopevalue"]:checked'
					).nextElementSibling.textContent;
				}
			} else if (filter === "role") {
				this.activeFilterType = "role";
				if (this.$el.querySelector('input[name="rolevalue"]:checked')) {
					this.activeFilterType = "role";
					this.activeFilterValue = this.$el.querySelector(
						'input[name="rolevalue"]:checked'
					).value;
					this.activeFilterValueDisplay = this.$el.querySelector(
						'input[name="rolevalue"]:checked'
					).nextElementSibling.textContent;
				}
			} else if (filter === "location") {
				this.activeFilterType = "location";
				if (this.$el.querySelector(".filter__location--min")) {
					this.activeFilterType = "location";
					this.activeFilterValue = this.$el.querySelector(
						".filter__location--min"
					).value;
					this.activeFilterValueDisplay = this.$el.querySelector(
						".filter__location--min-label span"
					).innerText;

					if (this.activeFilterValue !== "0") {
						this.$el
							.querySelector(".custom__label--rural")
							.classList.add("disabled");
					} else {
						this.$el
							.querySelector(".custom__label--rural")
							.classList.remove("disabled");
					}
					if (this.activeFilterValueMax !== "3") {
						this.$el
							.querySelector(".custom__label--urban")
							.classList.add("disabled");
					} else {
						this.$el
							.querySelector(".custom__label--urban")
							.classList.remove("disabled");
					}
				}
			}
		}

		// console.log("activeFilterType: ", this.activeFilterType);
		// console.log("activeFilterValue: ", this.activeFilterValue);
		// console.log("activeFilterValueMax: ", this.activeFilterValueMax);
		if (
			this.activeFilterType &&
			(this.activeFilterValue || this.activeFilterValueMax)
		) {
			this.filterParams.filtersOpen = true;
			this.$el.classList.add("filters--open");
		}
	}

	showFilters() {
		this.previewFilterType = "type";
		this.filterParams.filtersOpen = true;
		this.$el.classList.add("filters--open");
		// this.$el.classList.remove("pending-change");
		this.doURLChange = "force";
		this.filtersChanged();
	}

	closeFilters() {
		this.filterParams.filtersOpen = false;
		this.$el.classList.remove("filters--open");
		// this.filtersChanged();

		if (window.location.search.includes("viewing=")) {
			let newURL = window.location.href.split("?")[0];
			window.history.pushState(newURL, "Filter URL", newURL);
			this.fetchNewContent(newURL);
		}
	}

	filtersPreviewed() {
		this.$el.classList.add("pending-change");
		document.querySelector("body").classList.add("pending-change--body");
		let filter = this.$el.querySelector(
			'input[name="filter"]:checked'
		).value;

		// if there is a filterval or filtervalmax, run this.resetAllFilters()
		if (this.activeFilterValue || this.activeFilterValueMax) {
			this.resetAllFilters();
		}

		if (filter) {
			console.log("previewing filter: ", filter);
			this.previewFilterType = filter;
			this.doURLChange = true;

			if (this.doURLChange && this.allowURLChange) {
				this.setFilterURL();
			}
		}
	}

	filtersChanged(e) {
		if (this.allowURLChange === false) {
			return;
		} else {
			this.$el.classList.add("pending-change");
			document
				.querySelector("body")
				.classList.add("pending-change--body");
		}
		let filter = this.$el.querySelector(
			'input[name="filter"]:checked'
		).value;
		if (this.doURLChange === "force") {
			this.doURLChange = true;
		} else {
			this.doURLChange = false;
		}
		if (filter) {
			console.log("filter: ", filter);
			if (filter === "type") {
				this.activeFilterType = "type";
				if (this.$el.querySelector('input[name="typevalue"]:checked')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="typevalue"]:checked'
					).value;
					this.activeFilterValueMax = null;
					this.doURLChange = true;
				} else {
					// this.activeFilterValue = null;
				}
			} else if (filter === "size") {
				this.activeFilterType = "size";
				if (this.$el.querySelector('input[name="size__start"]')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="size__start"]'
					).value;
					this.activeFilterValueMax = this.$el.querySelector(
						'input[name="size__end"]'
					).value;
					this.doURLChange = true;
				} else {
					// this.activeFilterValue = null;
					// this.activeFilterValueMax = null;
				}
			} else if (filter === "year") {
				this.activeFilterType = "year";
				if (this.$el.querySelector('input[name="year__start"]')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="year__start"]'
					).value;
					this.activeFilterValueMax = this.$el.querySelector(
						'input[name="year__end"]'
					).value;
					this.doURLChange = true;
				} else {
					// this.activeFilterValue = null;
					// this.activeFilterValueMax = null;
				}
				if (e && e.target.id === "in-progress") {
					this.doURLChange = "force";
				}
			} else if (filter === "scope") {
				this.activeFilterType = "scope";
				if (
					this.$el.querySelector('input[name="scopevalue"]:checked')
				) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="scopevalue"]:checked'
					).value;
					this.activeFilterValueMax = null;
					this.doURLChange = true;
				} else {
					// this.activeFilterValue = null;
				}
			} else if (filter === "role") {
				this.activeFilterType = "role";
				if (this.$el.querySelector('input[name="rolevalue"]:checked')) {
					this.activeFilterValue = this.$el.querySelector(
						'input[name="rolevalue"]:checked'
					).value;
					this.activeFilterValueMax = null;
					this.doURLChange = true;
				} else {
					// this.activeFilterValue = null;
				}
			} else if (filter === "location") {
				this.activeFilterType = "location";
				if (this.$el.querySelector(".filter__location--min")) {
					this.activeFilterValue = this.$el.querySelector(
						".filter__location--min"
					).value;

					if (this.activeFilterValue !== "0") {
						this.$el
							.querySelector(".custom__label--rural")
							.classList.add("disabled");
					} else {
						this.$el
							.querySelector(".custom__label--rural")
							.classList.remove("disabled");
					}

					this.activeFilterValueMax = this.$el.querySelector(
						".filter__location--max"
					).value;
					if (this.activeFilterValueMax !== "3") {
						this.$el
							.querySelector(".custom__label--urban")
							.classList.add("disabled");
					} else {
						this.$el
							.querySelector(".custom__label--urban")
							.classList.remove("disabled");
					}
					this.doURLChange = true;
				} else {
					this.$el.classList.remove("pending-change");
					document
						.querySelector("body")
						.classList.remove("pending-change--body");
					// this.activeFilterValue = null;
				}
			}
		}

		// console.log("activeFilterType: ", this.activeFilterType);
		// console.log("activeFilterValue: ", this.activeFilterValue);

		if (this.doURLChange) {
			this.setFilterURL();
		}
	}

	resetAllFilters(){
		this.allowURLChange = false;
		this.$el.querySelectorAll('input[type="radio"]').forEach((el) => {
			if (el.name !== "filter") {
				el.checked = false;
			}
		});
		// this.$el.querySelector("#filter-type").checked = true;
		this.activeFilterType = null;
		this.activeFilterValue = null;
		this.activeFilterValueMax = null;
		this.activeFilterValueDisplay = null;
		this.$el.classList.remove("pending-change");
		document.querySelector("body").classList.remove("pending-change--body");

		// this.$el.querySelectorAll("input[data-reset]").forEach((el) => {
		// 	el.value = el.getAttribute("data-reset");
		// 	el.dispatchEvent(new Event("input", { bubbles: true }));
		// });

		if (window.rangeFunctions && window.rangeFunctions.length > 0) {
			window.rangeFunctions.forEach((range) => {
				range.resetRange();
			});
		}

		this.doURLChange = "force";
		this.allowURLChange = true;
		this.setFilterURL();
	}

	setFilterURL() {
		let filterURL = "/our-work/";
		if (
			this.activeFilterType &&
			this.activeFilterValue !== null &&
			this.activeFilterValue !== "null"
		) {
			filterURL +=
				this.activeFilterType + "/" + this.activeFilterValue + "/";
		}
		if (
			this.activeFilterValueMax &&
			this.activeFilterValueMax !== null &&
			this.activeFilterValueMax !== "null"
		) {
			filterURL += this.activeFilterValueMax + "/";
		}

		// console.log(filterURL);

		// if (this.$el.querySelector('input[name="filter"]:checked')) {
		// 	this.previewFilterType = this.$el.querySelector(
		// 		'input[name="filter"]:checked'
		// 	).value;
		// }

		if (
			(this.previewFilterType === "type" ||
				this.activeFilterType !== this.previewFilterType) &&
			this.previewFilterType
		) {
			filterURL += "?viewing=" + this.previewFilterType;
		}

		if (
			this.activeFilterType === "year" &&
			this.$el.querySelector("#in-progress")
		) {
			if (
				this.$el.querySelector("#in-progress") &&
				this.$el.querySelector("#in-progress").checked
			) {
				if (filterURL.includes("?")) {
					filterURL += "&in-progress=true";
				} else {
					filterURL += "?in-progress=true";
				}
			} else {
				if (filterURL.includes("?")) {
					filterURL += "&in-progress=false";
				} else {
					filterURL += "?in-progress=false";
				}
			}
		}

		console.log("filter URL: ", filterURL);

		// if the filterURL is the same as the current URL, don't fetch new content
		// console.log(filterURL, window.location.pathname);
		if (filterURL === window.location.pathname) {
			this.$el.classList.remove("pending-change");
			document
				.querySelector("body")
				.classList.remove("pending-change--body");
			return;
		}

		window.history.pushState(filterURL, "Filter URL", filterURL);
		this.fetchNewContent(filterURL);
	}

	fetchNewContent(url) {
		const scopeThis = this;
		// Cancel any ongoing fetch
		if (this.controller) {
			this.controller.abort();
		}
		this.controller = new AbortController();
		const signal = this.controller.signal;
		// Add loading class
		this.$el.classList.add("is-loading");
		document.querySelector("body").classList.add("is-loading--body");
		document.querySelector("body").classList.add("body--allow-animation");
		scopeThis.safetyNet = setTimeout(function () {
			scopeThis.$el.classList.remove("pending-change");
			scopeThis.$el.classList.remove("is-loading");
			document.querySelector("body").classList.remove("is-loading--body");
		}, 1000);
		fetch(url, { signal })
			.then((response) => {
				this.$el.classList.remove("is-loading");
				document
					.querySelector("body")
					.classList.remove("is-loading--body");
				return response.text();
			})
			.then((html) => {
				clearTimeout(scopeThis.safetyNet);
				scopeThis.$el.classList.remove("pending-change");
				document
					.querySelector("body")
					.classList.remove("pending-change--body");
				let parser = new DOMParser();
				let doc = parser.parseFromString(html, "text/html");
				let newContent = doc.querySelector(".card__grid--projects");
				let noFilterContent = doc.querySelector(".nofilter__block");

				if (newContent) {
					// console.log("newContent: ", newContent);
					document
						.querySelector(".card__grid--projects")
						.replaceWith(newContent);
				}

				if (noFilterContent) {
					// console.log("no filter block: ", noFilterContent);
					document
						.querySelector(".nofilter__block")
						.replaceWith(noFilterContent);
				}

				setTimeout(() => {
					this.postReturnCB();
				}, 200);
			})
			.catch((error) => {
				this.$el.classList.remove("is-loading");
				document
					.querySelector("body")
					.classList.remove("is-loading--body");
				if (error.name === "AbortError") {
					// expected and safe to ignore
					console.log("Previous fetch aborted");
				} else {
					console.error("Error:", error);
				}
				scopeThis.$el.classList.remove("pending-change");
				document
					.querySelector("body")
					.classList.remove("pending-change--body");
			});
	}
}
